/*  ショップ因子一覧検索フォーム Spanタグ */
import React, { memo } from 'react';
import SearchLabel from '../atoms/SearchLabel';
var SearchSpan = function (_a) {
    var label = _a.label, value = _a.value;
    return (React.createElement("div", { className: "col-md-4" },
        React.createElement(SearchLabel, { label: label }),
        React.createElement("span", { className: "search-form-input long" }, value)));
};
export default memo(SearchSpan);
